"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const NewCampaignPopover_1 = require("../NewCampaignPopover");
const export_1 = require("./export");
const ToolBar = ({ media, keyword, campaignStatus, campaignType, onCreate }) => {
    const style = {
        width: '100%',
        height: 47,
        flex: '0 0 auto',
        backgroundColor: src_1.almostWhite,
        borderTop: `1px ${src_1.titanium} solid`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingLeft: 32,
        paddingRight: 32,
    };
    if (media === 'Desktop') {
        return (React.createElement("div", { style: style },
            React.createElement(export_1.default, { keyword: keyword, campaignStatus: campaignStatus, campaignType: campaignType })));
    }
    if (media === 'Tablet') {
        return (React.createElement("div", { style: Object.assign(Object.assign({}, style), { justifyContent: 'flex-start', paddingLeft: 24, paddingRight: 0 }) }));
    }
    if (media === 'Mobile') {
        return (React.createElement("div", { style: Object.assign(Object.assign({}, style), { justifyContent: 'space-between', paddingLeft: 24, paddingRight: 24 }) },
            React.createElement(NewCampaignPopover_1.default, { onCreate: onCreate, media: media })));
    }
    return React.createElement("div", { style: style });
};
exports.default = ToolBar;
